<template>
    <div class="rating-success-modal">
        <div class="driver-modal" v-if="visibleDriverModal">
            <div class="perfect-rate">
                <img :src="dataRated.icon" alt="">
                <p>{{dataRated.text}}</p>
            </div>
        </div>
        <div class="restaurant-modal" v-else>

        </div>
         <button class="btn-close"
            @click="handleClose()">
            {{ $t(`SHARE_ORDER.rating_driver.close`)}}
        </button>
    </div>
</template>

<script>
const PERFECT_RATE = 5
export default {
    props: {
        rated : Number
    },
    data() {
        return {
            visibleDriverModal : true,
            dataRated : {
                icon : '',
                text : ''
            }
        }
    },
    methods : {
        handleClose() {
            this.$emit('onClose')
        }
    },
    mounted() {
        if(this.rated === PERFECT_RATE){
            this.dataRated.icon = '/img/icons/smiley.svg'
            this.dataRated.text = this.$t('SHARE_ORDER.rating_driver.message.smiley')
        }else{
            this.dataRated.icon = '/img/icons/sadly.svg'
            this.dataRated.text = this.$t('SHARE_ORDER.rating_driver.message.sadly')
        }
    }

}
</script>

<style lang="scss" scoped>
.rating-success-modal{
    .driver-modal{
        .perfect-rate{
            text-align: center;

            p{
                color: #7A8189;
                font-weight: 500;
                margin-top: 20px;
            }
        }
    }
    .btn-close {
        width: 100%;
        height: 45px;
        border: none;
        background: #ff8200;
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        border-radius: 4px;
        margin-top: 20px;
        outline: none;
    }
}
</style>